var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotionErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5ZM7.25 5.25C7.25 4.55964 7.80964 4 8.5 4C9.19036 4 9.75 4.55964 9.75 5.25V9.41667C9.75 10.107 9.19036 10.6667 8.5 10.6667C7.80964 10.6667 7.25 10.107 7.25 9.41667V5.25ZM8.5 11.5C7.80964 11.5 7.25 12.0596 7.25 12.75C7.25 13.4404 7.80964 14 8.5 14C9.19036 14 9.75 13.4404 9.75 12.75C9.75 12.0596 9.19036 11.5 8.5 11.5Z",
    fill: "#D81C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionErrorIcon);
export default __webpack_public_path__ + "static/media/motion-error-icon.8b5ed193587ce94cc3daf2a76049b6d4.svg";
export { ForwardRef as ReactComponent };